import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Text } from 'react-native';
import InfoIcon from '@/assets/icon/ic_info.svg';
import { BadgeShell, BadgeText } from '@/components/BadgeShell';
import PositionedModal from '@/components/PositionedModal';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
const ColorMap = {
    '0': { background: '#E6F4EB', text: '#06903B' },
    '1': { background: '#F0F9E7', text: '#64C40F' },
    '2': { background: '#FFF9E6', text: '#FFC109' },
    '3': { background: '#FFF4E6', text: '#FF9202' },
    '4': { background: '#FFEEE9', text: '#FF5722' },
    '5': { background: '#FCE9E9', text: '#E52123' },
    unknown: { background: '#E7E8E9', text: '#9A9B9F' },
    progress: { background: '#ffffff', text: '#FFC109', border: '#FFC109' },
};
export default function ScoreLabel({ score, isIconVisible, }) {
    var _a;
    const status = (() => {
        if (score === 'processing') {
            return 'progress';
        }
        else if (score === undefined) {
            return 'unknown';
        }
        else if (score <= 0) {
            return '0';
        }
        else if (score <= 1) {
            return '1';
        }
        else if (score <= 2) {
            return '2';
        }
        else if (score <= 3) {
            return '3';
        }
        else if (score <= 4) {
            return '4';
        }
        else {
            return '5';
        }
    })();
    return (_jsx(PositionedModal, { modalContent: _jsx(Text, { style: {
                fontSize: 12,
                fontFamily: font.pretendardMedium,
                color: color.white,
            }, children: "\uB808\uBCA8\uC774 \uB0AE\uC744 \uC218\uB85D \uB9E4\uC7A5 \uC785\uAD6C \uC811\uADFC\uC774 \uC26C\uC6CC\uC694." }), children: _jsxs(BadgeShell, { backgroundColor: ColorMap[status].background, textColor: ColorMap[status].text, borderColor: (_a = ColorMap[status].border) !== null && _a !== void 0 ? _a : ColorMap[status].background, borderRadius: 6, paddingHorizontal: isIconVisible ? 8 : 6, children: [_jsx(BadgeText, { textColor: ColorMap[status].text, children: score === 'processing'
                        ? '계산중(건물정보 필요)'
                        : `접근레벨 ${score === undefined ? '-' : score}` }), isIconVisible && _jsx(InfoIcon, { color: ColorMap[status].text })] }) }));
}
